import { useState, useEffect } from 'react';
import Sidebar from './Sidebar';

export default function Layout({ children }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return (
    <div style={{ backgroundColor: '#0d0b1e', minHeight: '100vh' }}>
      <Sidebar />
      <div className="main-content md:ml-[220px]" style={{ minHeight: '100vh', padding: isMobile ? '16px' : '32px', paddingTop: isMobile ? '68px' : '32px' }}>
        {children}
      </div>
    </div>
  );
}
